export default "__VITE_ASSET__9sw5qnDW__"